import { useTellescopeMutation } from "@tellescope/tanstack-query";
import { Button } from "@tellescope/ui";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppPermissionQuery } from "../../../permissions";

export interface LookbackVisibilityCellProps {
  isVisible: boolean;
  observationIds: string[];
}

export const LookbackVisibilityCell = ({ isVisible, observationIds }: LookbackVisibilityCellProps) => {
  const { t } = useTranslation("vitals");
  const toggleVisibilityMutation = useTellescopeMutation({
    model: "enduser_observations",
    method: "acknowledge",
  });

  const {
    update: { access: canToggle },
  } = useAppPermissionQuery({
    model: "enduser_observations",
    actions: ["update"],
  });

  return (
    <Button
      variant="ghost"
      onClick={(e) => {
        e.stopPropagation();
        toggleVisibilityMutation.mutate({
          ids: observationIds,
          excludeFromVitalCountLookback: !isVisible,
        });
      }}
      size="icon"
      hoverLabel={
        isVisible
          ? t("Hide from Historical Adherence")
          : t("Include in Historical Adherence (all vitals are included by default)")
      }
      disabled={!canToggle}
    >
      {isVisible ? <Eye /> : <EyeOff />}
    </Button>
  );
};
